import { Injectable, Output, EventEmitter } from '@angular/core'

import { JwtHelperService } from '@auth0/angular-jwt'

import { environment } from '../../environments/environment'
import { GeneralService } from './general.service'

@Injectable()
export class AzureADService {
    jwtHelper = new JwtHelperService()
    @Output() initEvent: EventEmitter<any> = new EventEmitter<any>()

    public static azureClientId = ''
    public static azureTenantId = ''

    public static azureLoginAPI =
        'https://login.microsoftonline.com/' + AzureADService.azureTenantId
    public static redirectUrl = environment.apiUrl + 'azureAD/AzureADLogin'

    constructor() {}

    initApp(
        domainSecureInfo: any,
        email: string,
        state: string = 'gettingStarted'
    ) {
        let domainSecureInfoObj = JSON.parse(domainSecureInfo)
        AzureADService.azureTenantId = domainSecureInfoObj.azureTenantId
        AzureADService.azureClientId = domainSecureInfoObj.azureClientId
        AzureADService.azureLoginAPI =
            'https://login.microsoftonline.com/' + AzureADService.azureTenantId

        let uuid = GeneralService.getNewUUID()

        let azureAdUrl: string = `https://login.microsoftonline.com/${domainSecureInfoObj.azureTenantId}/oauth2/v2.0/authorize?client_id=${domainSecureInfoObj.azureClientId}&response_type=id_token+token
      &redirect_uri=${AzureADService.redirectUrl}&scope=openid+profile+https%3A%2F%2Fwebapi.aub.edu.lb%2F.default&state=${state}&nonce=${uuid}&force_refresh=true&response_mode=form_post&login_hint=${email}`

        setTimeout(() => {
            window.open(azureAdUrl, '_self')
        }, 1000)
    }
}
